import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { useCssStyle } from '../../customHook/getCssStyle';
import { CustomModal } from '../customModal';
import CustomPressable from '../customPressable/customPressable';
import { useTranslation } from 'react-i18next';
import { ImageComp } from '../Image/Image';
import { CROSS_ERROR, SUCCESS_CHECK } from '../../assets';
import Loader from '../Loader/loader';

const InfoPopupModal = ({ type, title, subtitle, children, onClose, secondaryBtnLabel, onContinue, primaryBtnLabel, disablePrimaryBtn=false, disableSecondaryBtn=false }) => {
    const getStyles = useCssStyle();
    const { t } = useTranslation();


    return (
        <CustomModal>
            <View style={getStyles(['infoModalContainer'])}>

                {
                    type == "success" ?
                        <View style={getStyles(['infoModalSuccessContainer'])} >
                            <ImageComp source={SUCCESS_CHECK} style={getStyles(['infoModalSuccessContainerBackgroundImg'])} />
                        </View>
                        : type == "error" ?
                            <View style={getStyles(['infoModalSuccessContainer'])} >
                                {/* <ImageComp source={CROSS_ERROR} style={getStyles(['infoModalSuccessContainerBackgroundImg'])} /> */}
                            </View> :
                            type == "loading" ?
                                <Loader style={getStyles(['infoModalLoader'])} /> :
                                null
                }

                {/* Title */}
                {title && (
                    <Text style={getStyles(['infoModalTitle'])}>
                        {title}
                    </Text>
                )}

                {/* Subtitle */}
                {subtitle && (
                    <Text style={getStyles(['infoModalSubTitle'])}>
                        {subtitle}
                    </Text>
                )}

                {/* Children */}
                {children && <View >
                    {children}
                </View>}

                {/* Button */}
                {onContinue && <CustomPressable style={getStyles(['primaryBtn'])} onPress={onContinue} disabled={disablePrimaryBtn}>
                    <Text style={getStyles(['primaryBtnTxt'])}>{primaryBtnLabel || "Continue"}</Text>
                </CustomPressable>}

                {onClose && <CustomPressable style={getStyles(['secondaryBtn'])} onPress={onClose} disabled={disableSecondaryBtn}>
                    <Text style={getStyles(['secondaryBtnTxt'])}>{secondaryBtnLabel || "Close"}</Text>
                </CustomPressable>}
            </View>
        </CustomModal>
    );
};



export default InfoPopupModal;